import React from 'react';
import { Form, Input, Checkbox } from 'antd';

const InputGroup = Input.Group;

export default function Footer(props) {
    return (
        <div className="row">
            <div className={"col-md-6"}>
                <Form.Item>
                    <InputGroup compact>
                        <Form.Item style={{ width: '33.33%' }}>
                            <Checkbox
                                checked={props.formValues.flagExportacion}
                            >
                                Exportación
                            </Checkbox>
                        </Form.Item>
                        <Form.Item style={{ width: '33.33%' }}>
                            <Checkbox
                                checked={props.formValues.flagDescuentoGlobal}
                            >
                                Descuento Global
                            </Checkbox>
                        </Form.Item>
                        <Form.Item style={{ width: '33.33%' }}>
                            <Checkbox
                                checked={props.formValues.flagDetraccion}
                            >
                                Detracción
                            </Checkbox>
                        </Form.Item>
                        <Form.Item style={{ width: '33.33%' }}>
                            <Checkbox
                                checked={props.formValues.flagRetencion}
                            >
                                Retención
                            </Checkbox>
                        </Form.Item>

                    </InputGroup>
                </Form.Item>
            </div>
            <div className="col-md-3 form-group">
                <Form.Item label='' style={{ display: props.formValues.flagDetraccion ? '' : 'none' }}>
                    <Input readOnly
                        value={props.formValues.nombreDetraccion}
                    />
                </Form.Item>
            </div>
            <div className="col-md-3 pt-10">

                {["01", "03"].includes(props.formValues.codigoSunatTipoComprobante) ? (
                    <>
                        <div className="col text-right mb-5" style={{ display: props.formValues.flagPercepcion ? "" : "none" }}>
                            <div className="total-inline">
                                <label>Porcentaje Percepción</label>
                                <div>{props.formValues.porcentajePercepcion.toFixed(2)}</div>
                            </div>
                        </div>
                        <div className="col text-right mb-5" style={{ display: props.formValues.flagDetraccion ? "" : "none" }}>
                            <div className="total-inline">
                                <label>Porcentaje Detracción</label>
                                <div>{props.formValues.porcentajeDetraccion.toFixed(2)}</div>
                            </div>
                        </div>
                    </>)
                    : null

                }

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Detalle</label>
                        <div>{props.formValues.totalDetalle.toFixed(2)}</div>
                    </div>
                </div>
                {props.formValues.flagDescuentoGlobal ?
                    <div className="col text-right mb-5" >
                        <div className="total-inline">
                            <label>Total Dscto. Global</label>
                            <div>{props.formValues.importeDescuentoGlobal.toFixed(2)}</div>
                        </div>
                    </div> : null

                }

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Dscto. Item</label>
                        <div>{props.formValues.importeDescuento.toFixed(2)}</div>
                    </div>
                </div>

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Sub Total</label>
                        <div>{props.formValues.subTotal.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>IGV</label>
                        <div>{props.formValues.igv.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>ISC</label>
                        <div>{props.formValues.totalDetalleISC.toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total</label>
                        <div>{props.formValues.total.toFixed(2)}</div>
                    </div>
                </div>

                {["01", "03"].includes(props.formValues.codigoSunatTipoComprobante) ? (
                    <>
                        <div className="col text-right mb-5" style={{ display: props.formValues.flagPercepcion ? "" : "none" }}>
                            <div className="total-inline">
                                <label>Importe Persepción</label>
                                <div>{props.formValues.importePercepcion.toFixed(2)}</div>
                            </div>
                        </div>
                        <div className="col text-right mb-5" style={{ display: props.formValues.flagPercepcion ? "" : "none" }}>
                            <div className="total-inline">
                                <label>Total Percepción</label>
                                <div>{props.formValues.totalPercepcion.toFixed(2)}</div>
                            </div>
                        </div>
                        <div className="col text-right mb-5" style={{ display: props.formValues.flagDetraccion ? "" : "none" }}>
                            <div className="total-inline">
                                <label>Importe Detracción</label>
                                <div>{props.formValues.importeDetraccion.toFixed(2)}</div>
                            </div>
                        </div>
                        <div className="col text-right mb-5" style={{ display: props.formValues.flagDetraccion ? "" : "none" }}>
                            <div className="total-inline">
                                <label>Total Detracción</label>
                                <div>{props.formValues.totalDetraccion.toFixed(2)}</div>
                            </div>
                        </div>


                        <div className="col text-right mb-5" style={{ display: props.formValues.flagRetencion ? "" : "none" }}>
                            <div className="total-inline">
                                <label>Porcentaje Retención</label>
                                <div>{props.formValues.porcentajeRetencion.toFixed(2)}%</div>
                            </div>
                        </div>

                        <div className="col text-right mb-5" style={{ display: props.formValues.flagRetencion ? "" : "none" }}>
                            <div className="total-inline">
                                <label>Importe Retención</label>
                                <div>{props.formValues.importeRetencion.toFixed(2)}</div>
                            </div>
                        </div>


                    </>
                ) : null

                }

            </div>
        </div>
    );
}